import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordFormModalData } from 'src/app/interface/components/forms/change-password-form-modal.interface';

@Component({
  selector: 'common-change-password-form-modal',
  templateUrl: './change-password-form-modal.component.html',
  styleUrls: ['./change-password-form-modal.component.scss'],
})
export class ChangePasswordFormModalComponent {
  title = 'tenant.passwordManagement.title';
  labelButtonCancel = 'buttons.cancel';
  labelButtonSave = 'buttons.save';
  minLength = 6;

  form: FormGroup;
  hideNew = true;
  hideConfirm = true;

  constructor(
    private fb: FormBuilder,
    private matDialogRef: MatDialogRef<ChangePasswordFormModalComponent>,
    private translate: TranslateService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: ChangePasswordFormModalData,
  ) {
    if (this.data?.title) this.title = this.data.title;
    if (this.data?.labelButtonCancel) this.labelButtonCancel = this.data.labelButtonCancel;
    if (this.data?.labelButtonSave) this.labelButtonSave = this.data.labelButtonSave;
    if (this.data?.minLength != null && this.data.minLength > 0) {
      this.minLength = this.data.minLength;
    }

    this.form = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(this.minLength)]],
      confirmPassword: ['', [Validators.required]],
    });
  }

  onRecoveryLinkClick(): void {
    this.data?.onSendRecoveryEmail?.();
  }

  get passwordMismatch(): boolean {
    const np = this.form.get('newPassword')?.value;
    const cp = this.form.get('confirmPassword')?.value;
    if (np == null || cp == null || np === '' || cp === '') return false;
    return String(np) !== String(cp);
  }

  get saveDisabled(): boolean {
    const npCtrl = this.form.get('newPassword');
    const cpCtrl = this.form.get('confirmPassword');
    if (!npCtrl || !cpCtrl) return true;
    if (npCtrl.invalid || cpCtrl.invalid) return true;
    return this.passwordMismatch;
  }

  onEventClose(): void {
    this.matDialogRef.close();
  }

  onEventCancel(): void {
    this.matDialogRef.close();
  }

  onEventSave(): void {
    if (this.form.get('newPassword')?.invalid || this.form.get('confirmPassword')?.invalid) {
      this.form.markAllAsTouched();
      if (this.form.get('newPassword')?.hasError('minlength')) {
        this.toastr.warning(this.translate.instant('toastrMessage.warning.passwordMinLength'));
      }
      return;
    }

    if (this.passwordMismatch) {
      this.toastr.error(this.translate.instant('tenant.passwordManagement.errors.passwordMismatch'));
      return;
    }

    const newPassword = String(this.form.get('newPassword')?.value ?? '').trim();
    this.matDialogRef.close({ newPassword });
  }
}
